angular.module('TetherApp').controller('LocationController', [
    '$window',
    'locationService',
    'locationModalService',
    function (
        $window,
        locationService,
        locationModalService
    ) {
        let self = this;
        self.nearbyLocations = [];
        self.linkLocationId;
        self.client_id;
        self.newLocation = {};
        self.generalError = '';

        self.delete = function(locationId) {
            if($window.confirm(self.deleteConfirmationText)) {
                locationService.deleteLocation(locationId)
                    .then(onLocationDelete, onError);
            }
        };

        let onLocationDelete = function (data) {
            $window.location.reload();
        };

        let onError = function(reason) {
            // console.log('Error occurred while deleting keyword');
        };

        let onGoogleMapsModal = function () {

        };

        self.date = function(dateString){
            return new Date(dateString);
        };

        self.googleMapsModal = function (event, locationId) {
            if (locationId != undefined && locationId != '') {
                locationModalService.getGoogleMapsModal(event, locationId)
                    .then(onGoogleMapsModal, onError);
            }
        };

        let onAllCampaignLocationsGoogleMapsModal = function () {

        };

        self.allCampaignLocationsGoogleMapsModal = function (event, campaignId) {
            if (campaignId != undefined && campaignId != '') {
                locationModalService.getAllCampaignLocationsGoogleMapsModal(event, campaignId)
                    .then(onAllCampaignLocationsGoogleMapsModal, onError);
            }
        };

        let onListNearbyLocationsForLinkLocation = function (data) {
            self.nearbyLocations = data;
        };

        self.listNearbyLocationsForLinkLocation = function(linkLocationId) {
            locationService.listNearbyLocationsForLinkLocation(linkLocationId)
                .then(onListNearbyLocationsForLinkLocation, onError);
        };

        let onLinkLocationAttach = function (data) {
            self.listNearbyLocationsForLinkLocation(self.linkLocationId);
        };

        self.linkLocationAttach = function(locationId, linkLocationId){
            locationService.linkLocationAttach(locationId, linkLocationId)
                .then(onLinkLocationAttach, onError);
        }

        let onLinkLocationDetach = function (data) {
            self.listNearbyLocationsForLinkLocation(self.linkLocationId);
        };

        self.linkLocationDetach = function(locationId, linkLocationId){
            locationService.linkLocationDetach(locationId, linkLocationId)
                .then(onLinkLocationDetach, onError);
        }

        let onCreateLocationAndAttachLinkLocation = function (data) {
            self.newLocation = {};
        }

        let onCreateLocationAndAttachLinkLocationError = function(data) {
            self.generalError = data.data.errors.general;
            // console.log(self.generalError);
        };

        self.createLocationAndAttachLinkLocation = function() {
            self.newLocation.linkLocation = self.linkLocationId;
            self.newLocation.client_id = self.client_id;
            self.generalError = '';

            locationService.createLocationAndAttachLinkLocation(self.newLocation)
                .then(onCreateLocationAndAttachLinkLocation, onCreateLocationAndAttachLinkLocationError);
        }

        let onSetLinkLocationNotAttributable = function (data) {
        };

        self.setLinkLocationNotAttributable = function(linkLocationId){
            if (confirm("Mark click as not attributable?")) {
                locationService.setLinkLocationNotAttributable(linkLocationId)
                    .then(onSetLinkLocationNotAttributable, onError);
            }
        }

        let onSetLinkLocationAttributable = function (data) {
        };

        self.setLinkLocationAttributable = function(linkLocationId){
            if (confirm("Mark click as attributable?")) {
                locationService.setLinkLocationAttributable(linkLocationId)
                    .then(onSetLinkLocationAttributable, onError);
            }
        }

    }
]);
